<template>
  <div class="product-item">
    <a
      :href="url"
      class="product-item__image-wrapper"
      :title="`Product: ${title}`"
      :aria-label="`Product: ${title}`"
      style="--aspect-ratio: 0.75"
      @mouseover="hover = $screen.laptop_up"
      @mouseleave="hover = false">
      <transition name="fade">
        <VImg
          v-show="activeImage"
          :media="activeImage"
          :fixedSize="imageSize"
          class="product-item__main-img"
          :customClass="{
            lazyload: hover,
            'remove-transition': lazyloaded,
          }"
          @loaded="lazyloaded += 1"
          :key="key" />
      </transition>
      <VImg
        v-if="hoverImage"
        :media="hoverImage"
        :fixedSize="imageSize"
        class="product-item__hover-img"
        :customClass="{
          hovering: hover,
          'remove-transition': lazyloaded,
        }"
        @loaded="lazyloaded += 1"
        :key="key" />
    </a>
    <div class="product-item__details">
      <p class="h5 product-item__title" v-text="title"></p>
      <p class="h6 product-item__vendor" v-text="product.vendor"></p>
      <p class="h6 product-item__price">
        <span v-text="$money(price)"></span>
        <s v-if="salePrice" class="price--sale" v-text="$money(salePrice)"></s>
      </p>
    </div>
  </div>
</template>

<script>
import VImg from './VImg.vue';

export default {
  name: 'ProductItem',

  components: {
    VImg,
  },

  props: ['product', 'collection', 'has_default_variant'],

  data() {
    return {
      key: 0,
      hover: false,
      lazyloaded: 0,
      featuredLazyLoaded: false,
      imageSize: '550x',
    };
  },

  computed: {
    title() {
      return this.product.title;
    },
    vendor() {
      return this.product.vendor;
    },
    handle() {
      return this.product.handle;
    },
    price() {
      return this.product.price;
    },
    salePrice() {
      return this.product.compare_at_price;
    },
    url() {
      return typeof this.collection !== 'undefined'
        ? `/collections/${this.collection}/products/${this.handle}`
        : `/products/${this.handle}`;
    },
    images() {
      return this.product.media;
    },
    activeImage() {
      if (this.images.length === 0) return window.PSTheme.Settings.NoImage;
      return this.images[0];
    },
    hoverImage() {
      if (this.images.length > 1) return this.images[1];
    },
  },

  created() {
    const preloadImages = [];
    if (this.images)
      preloadImages.push(
        this.images[0].src ? this.images[0].src : this.images[0]
      );
    if (this.images.length > 1)
      preloadImages.push(
        this.images[1].src ? this.images[1].src : this.images[1]
      );
    this.$preloadImages(preloadImages, this.imageSize);
  },

  watch: {
    // re-render the template programmatically
    activeImage: {
      handler() {
        this.key = (Math.random() * (999 - 0 + 1)) << 0;
      },
      deep: true,
    },
  },
};
</script>
